
























import Vue from "vue";
import moment from "moment";
import * as routes from "@/router/routes";

import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import MetricsFilterCard from "./MetricsFilterCard.vue";
import MetricsMainTable from "./MetricsMainTable.vue";
import MetricsTotalCard from "./MetricsTotalCard.vue";
import { dataTableItemsPerPage } from "@/utility/Constants";

import { FetchInstallationsNetworkMetricsReqData, FetchInstallationsNetworkMetricsCommand } from "@/model/communication/networkMetrics/FetchInstallationsNetworkMetricsCommand";
import { FetchInstallationNetworkMetricsResData } from "@/model/communication/networkMetrics/FetchInstallationsNetworkMetricsResData";
import { GetNetworkMetricsTotalCommand } from "@/model/communication/networkMetrics/GetNetworkMetricsTotalCommand";
import { GetNetworkMetricsTotalResData } from "@/model/communication/networkMetrics/GetNetworkMetricsTotalResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default Vue.extend({
    components: {
        StandardPage,
        MetricsFilterCard,
        MetricsMainTable,
        MetricsTotalCard,
    },
    data() {
        return {
            MetricsMainTable,
            routes,
            loading: false,
            totalsLoading: false,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            dataTableItemsPerPage,
            metricsTotals: null,
            lastSort: "",
            lastDesc: null,
        };
    },
    methods: {
        async sendRequest(request: FetchInstallationsNetworkMetricsReqData) {
            try {
                if (request.orderBy && request.orderBy.length > 0 && (request.orderBy[0] != this.lastSort || request.orderByDescending[0] != this.lastDesc)) {
                    this.lastSort = request.orderBy[0];
                    this.lastDesc = request.orderByDescending[0];
                } else this.sendRequestTotals(request);
                this.loading = true;
                this.reqData = request;
                if (
                    request.webSocketMetricStartDate == null ||
                    request.webSocketMetricStartDate == undefined ||
                    request.webSocketMetricEndDate == null ||
                    request.webSocketMetricEndDate == undefined
                ) {
                    request.webSocketMetricStartDate = moment().subtract(1, "weeks").utc().toDate();
                    request.webSocketMetricEndDate = moment().utc().toDate();
                }

                let response: FetchInstallationNetworkMetricsResData = await new FetchInstallationsNetworkMetricsCommand(request).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.totalInstallationsCount;
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationsNetworkMetrics request ", e);
            }
            this.loading = false;
        },

        async sendRequestTotals(request: FetchInstallationsNetworkMetricsReqData) {
            try {
                this.totalsLoading = true;
                this.reqData = request;
                if (
                    request.webSocketMetricStartDate == null ||
                    request.webSocketMetricStartDate == undefined ||
                    request.webSocketMetricEndDate == null ||
                    request.webSocketMetricEndDate == undefined
                ) {
                    request.webSocketMetricStartDate = moment().subtract(1, "weeks").utc().toDate();
                    request.webSocketMetricEndDate = moment().utc().toDate();
                }

                let response: GetNetworkMetricsTotalResData = await new GetNetworkMetricsTotalCommand(request).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.metricsTotals = {
                        totalByteSent: response.totalByteSent,
                        totalByteReceived: response.totalByteReceived,
                        dailyTotalByteSent: response.dailyTotalByteSent,
                        dailyTotalByteReceived: response.dailyTotalByteReceived,
                        daysList: response.daysList,
                    };
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationsNetworkMetrics request ", e);
            }
            this.totalsLoading = false;
        },

        async sendRequestAndBackToTheFirstPage(request) {
            this.$refs.standardPage.backToTheFirst();
            this.sendRequest(request);
        },
    },
});
